import * as React from 'react';
export const DropDownArrow = 
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="16"
    viewBox="0 0 18 18"
  >
    <path d="M5 8l4 4 4-4z" />
  </svg>
;

export const customStyle = {
  control: (base, state) => ({
    ...base,
    borderTop: '0 !important',
    borderLeft: '0 !important',
    borderRight: '0 !important',
    borderRadius: '0 !important',
    borderWidth: state.isFocused ? '2px !important' : '0.5px !important',
    borderColor: state.isFocused ? ' #4e5052 !important' : '#e9edf2 !important',
    boxShadow: state.isFocused ? 'grey !important' : '0 !important',
  })
}

/** React-select en paneles de filtro (.filter-card): bordes completos y esquinas redondeadas */
export const customStyleFilter = {
  control: (base, state) => ({
    ...base,
    borderRadius: 10,
    border: `1px solid ${state.isFocused ? '#20aee3' : '#cfd7e0'}`,
    minHeight: 42,
    boxShadow: state.isFocused
      ? '0 0 0 3px rgba(32, 174, 227, 0.2)'
      : '0 1px 2px rgba(15, 23, 42, 0.04)',
    backgroundColor: '#fff',
    transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
  }),
  menu: (base) => ({
    ...base,
    borderRadius: 10,
    overflow: 'hidden',
    boxShadow: '0 12px 32px rgba(15, 23, 42, 0.12)',
    border: '1px solid #e5e9ef',
    zIndex: 20,
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  menuList: (base) => ({
    ...base,
    padding: '6px 0',
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? '#20aee3'
      : state.isFocused
        ? 'rgba(32, 174, 227, 0.12)'
        : 'transparent',
    color: state.isSelected ? '#fff' : '#263238',
    cursor: 'pointer',
  }),
  placeholder: (base) => ({
    ...base,
    color: '#8d97ad',
    fontSize: '0.9375rem',
  }),
  singleValue: (base) => ({
    ...base,
    color: '#263238',
    fontSize: '0.9375rem',
  }),
  input: (base) => ({
    ...base,
    color: '#263238',
  }),
  indicatorSeparator: () => ({ display: 'none' }),
}



export const EstiloCombos = {
  control: (base, state) => ({
    ...base,
    borderTop: '1 !important',
    borderLeft: '1 !important',
    borderRight: '1 !important',
    borderRadius: '1 !important',
    borderWidth: state.isFocused ? '2px !important' : '0.5px !important',
    borderColor: state.isFocused ? ' #4e5052 !important' : '#a1abb6 !important',
    boxShadow: state.isFocused ? 'grey !important' : '0 !important',
  })
}

export const TrashBinIcon = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    className="bi bi-trash color-gris-megatone"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
    <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
  </svg>
);